import React, { useEffect, useMemo, useCallback } from 'react';
import lodash from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import config from '@/configs/config';
import Filters from '../components/Filters';
import preOrderImage from '../images/pre_order.png';
import bestsellerImage from '../images/best_seller.png';
import goodsStatusImage from '../images/goods_status.png';
import freshImage from '../images/fresh.png';
import { FILTER, FILTER_STRING } from '../constants';
import useQueryString from '../../hooks/useQueryString';

export const FILTER_IMAGE = {
  [FILTER.FRESH]: freshImage,
  [FILTER.PRE_ORDER]: preOrderImage,
  [FILTER.BESTSELLER]: bestsellerImage,
  [FILTER.GOODS_STATUS]: goodsStatusImage,
};

export default () => {
  const history = useHistory();
  const { search } = useLocation();
  const { filter: selectedFilter } = useQueryString();
  const activedFilter = selectedFilter || FILTER.PRE_ORDER;

  const filters = useMemo(() => {
    if (config.modules?.['daily-fresh-pre-orders'] === false) return [];

    const result = lodash.values(FILTER).map((value) => ({
      value,
      name: FILTER_STRING[value],
      imageUrl: FILTER_IMAGE[value],
    }));

    return result;
  }, []);

  const onItemButtonClick = useCallback((value) => {
    const url = new URLSearchParams(search);

    if (value) url.set('filter', value);
    else url.delete('filter');

    const newSearch = `?${url.toString()}`;

    history.push({ search: newSearch });
  }, [search, history]);

  useEffect(() => {
    if (
      config.modules?.['daily-fresh-pre-orders'] === false
      && activedFilter !== FILTER.GOODS_STATUS
    ) {
      onItemButtonClick(FILTER.GOODS_STATUS);
    }
  }, [activedFilter, onItemButtonClick]);

  return (
    <Filters
      activedFilter={activedFilter}
      filters={filters}
      onItemButtonClick={onItemButtonClick}
    />
  );
};
